import React from 'react';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';

export default function HypertouchDevicesEmptyState({ viewLoading, totalDevicesCount }) {
  if (viewLoading) {
    return <ListLoadingView />;
  }
  if (totalDevicesCount === 0) {
    return (
      <EmptyView
        title="noHypertouchDevicesFound"
        iconName="icon-simple-line-icons-screen-smartphone"
      />
    );
  }
  return null;
}
